import a_bit_cold from "../../../src/assets/sounds/lesson9/a_bit_cold.mp3"
import agree from "../../../src/assets/sounds/lesson9/agree.mp3"
import airport from "../../../src/assets/sounds/lesson9/airport.mp3"
import autumn from "../../../src/assets/sounds/lesson9/autumn.mp3"
import between from "../../../src/assets/sounds/lesson9/between.mp3"
import changeable from "../../../src/assets/sounds/lesson9/changeable.mp3"
import checked from "../../../src/assets/sounds/lesson9/checked.mp3"
import cold from "../../../src/assets/sounds/lesson9/cold.mp3"
import come from "../../../src/assets/sounds/lesson9/come.mp3"
import comfortable from "../../../src/assets/sounds/lesson9/comfortable.mp3"
import cool from "../../../src/assets/sounds/lesson9/cool.mp3"
import differences from "../../../src/assets/sounds/lesson9/differences.mp3"
import different from "../../../src/assets/sounds/lesson9/different.mp3"
import dry from "../../../src/assets/sounds/lesson9/dry.mp3"
import end_of from "../../../src/assets/sounds/lesson9/end_of.mp3"
import fall from "../../../src/assets/sounds/lesson9/fall.mp3"
import from_to from "../../../src/assets/sounds/lesson9/from_to.mp3"
import great_idea from "../../../src/assets/sounds/lesson9/great_idea.mp3"
import hot from "../../../src/assets/sounds/lesson9/hot.mp3"
import i_am from "../../../src/assets/sounds/lesson9/i_am.mp3"
import if_so from "../../../src/assets/sounds/lesson9/if_so.mp3"
import interesting from "../../../src/assets/sounds/lesson9/interesting.mp3"
import place from "../../../src/assets/sounds/lesson9/place.mp3"
import plan from "../../../src/assets/sounds/lesson9/plan.mp3"
import rainy from "../../../src/assets/sounds/lesson9/rainy.mp3"
import region from "../../../src/assets/sounds/lesson9/region.mp3"
import season from "../../../src/assets/sounds/lesson9/season.mp3"
import special from "../../../src/assets/sounds/lesson9/special.mp3"
import spring from "../../../src/assets/sounds/lesson9/spring.mp3"
import start from "../../../src/assets/sounds/lesson9/start.mp3"
import summer from "../../../src/assets/sounds/lesson9/summer.mp3"
import temperature from "../../../src/assets/sounds/lesson9/temperature.mp3"
import this_occasion from "../../../src/assets/sounds/lesson9/this_occasion.mp3"
import tomorrow from "../../../src/assets/sounds/lesson9/tomorrow.mp3"
import very_nice from "../../../src/assets/sounds/lesson9/very_nice.mp3"
import very from "../../../src/assets/sounds/lesson9/very.mp3"
import weatcher from "../../../src/assets/sounds/lesson9/weatcher.mp3"
import wet from "../../../src/assets/sounds/lesson9/wet.mp3"
import winter from "../../../src/assets/sounds/lesson9/winter.mp3"
import you from "../../../src/assets/sounds/lesson9/you.mp3"


import a_bit_cold_pic from "../../../src/assets/lesson9/winter_pic.png"
import agree_pic from "../../../src/assets/lesson9/agree_pic.png"
import airport_pic from "../../../src/assets/lesson9/airport_pic.png"
import autumn_pic from "../../../src/assets/lesson9/autumn_pic.png"
import between_pic from "../../../src/assets/lesson9/between_pic.png"
import changeable_pic from "../../../src/assets/lesson9/changeable_pic.png"
import checked_pic from "../../../src/assets/lesson9/checked_pic.png"
import cold_pic from "../../../src/assets/lesson9/cold_pic.png"
import come_pic from "../../../src/assets/lesson9/come_pic.png"
import comfortable_pic from "../../../src/assets/lesson9/comfortable_pic.png"
import cool_pic from "../../../src/assets/lesson9/cool_pic.png"
import differences_pic from "../../../src/assets/lesson9/changeable_pic.png"
import different_pic from "../../../src/assets/lesson9/changeable_pic.png"
import dry_pic from "../../../src/assets/lesson9/dry_pic.png"
import end_of_pic from "../../../src/assets/lesson9/end_of_pic.png"
import fall_pic from "../../../src/assets/lesson9/autumn_pic.png"
import from_to_pic from "../../../src/assets/lesson9/from_to_pic.png"
import great_idea_pic from "../../../src/assets/lesson9/great_idea_pic.png"
import hot_pic from "../../../src/assets/lesson9/hot_pic.png"
import i_am_pic from "../../../src/assets/lesson9/i_am_pic.png"
import if_so_pic from "../../../src/assets/lesson9/if_so_pic.png"
import interesting_pic from "../../../src/assets/lesson9/interesting_pic.png"
import place_pic from "../../../src/assets/lesson9/place_pic.png"
import plan_pic from "../../../src/assets/lesson9/plan_pic.png"
import rainy_pic from "../../../src/assets/lesson9/wet_pic.png"
import region_pic from "../../../src/assets/lesson9/region_pic.png"
import season_pic from "../../../src/assets/lesson9/season_pic.png"
import special_pic from "../../../src/assets/lesson9/special_pic.png"
import spring_pic from "../../../src/assets/lesson9/spring_pic.png"
import start_pic from "../../../src/assets/lesson9/start_pic.png"
import summer_pic from "../../../src/assets/lesson9/summer_pic.png"
import temperature_pic from "../../../src/assets/lesson9/temperature_pic.png"
import this_occasion_pic from "../../../src/assets/lesson9/this_occasion_pic.png"
import tomorrow_pic from "../../../src/assets/lesson9/tomorrow_pic.png"
import very_nice_pic from "../../../src/assets/lesson9/very_nice_pic.png"
import very_pic from "../../../src/assets/lesson9/very_pic.png"
import weatcher_pic from "../../../src/assets/lesson9/weatcher_pic.png"
import wet_pic from "../../../src/assets/lesson9/wet_pic.png"
import winter_pic from "../../../src/assets/lesson9/winter_pic.png"
import you_pic from "../../../src/assets/lesson9/you_pic.png"

export const unit_9=[
    {id: 0, english: "Tomorrow", vietnamese: "Ngày mai", example:"Ngày mai là một ngày nghỉ", audio:tomorrow, picture:tomorrow_pic},
    {id: 1, english: "Weatcher", vietnamese: "Thời tiết", example:"Thời tiết xấu", audio:weatcher, picture:weatcher_pic},
    {id: 2, english: "You", vietnamese: "Cậu", example:"Cậu", audio:you, picture:you_pic},
    {id: 3, english: "I", vietnamese: "Tớ", example:"Tôi sẽ đi", audio:i_am, picture:i_am_pic},
    {id: 4, english: "Great idea", vietnamese: "Ý kiến rất hay", example:"Ý kiến rất hay", audio:great_idea, picture:great_idea_pic},
    {id: 5, english: "A bit cold", vietnamese: "Hơi lạnh", example:"Hơi lạnh", audio:a_bit_cold, picture:a_bit_cold_pic},
    {id: 6, english: "Start", vietnamese: "Xuất phát", example:"Xuất phát", audio:start, picture:start_pic},
    {id: 7, english: "Region", vietnamese: "Miền", example:"Region", audio:region, picture:region_pic},
  
    {id: 8, english: "Comfortable/pleasure", vietnamese: "Dễ chịu", example:"Tôi hài lòng", audio:comfortable, picture:comfortable_pic},
    {id: 9, english: "If so", vietnamese: "Nếu vậy thì", example:"Nếu vậy thì", audio:if_so, picture:if_so_pic},
    {id: 10, english: "Checked", vietnamese: "Đã xem", example:"Checked", audio:checked, picture:checked_pic},
    {id: 11, english: "Very nice/great", vietnamese: "Rất tuyệt", example:"Đó là một ý tưởng tuyệt vời", audio:very_nice, picture:very_nice_pic},
    {id: 12, english: "Airport", vietnamese: "Sân bay", example:"Chúng tôi đang đi đến sân bay", audio:airport, picture:airport_pic},
    {id: 13, english: "Agree", vietnamese: "Đồng ý", example:"Đồng ý", audio:agree, picture:agree_pic},
    {id: 14, english: "Hot", vietnamese: "Nóng", example:"Cà phê nóng", audio:hot, picture:hot_pic},
    {id: 15, english: "Cold", vietnamese: "Lạnh", example:"Trà lạnh", audio:cold, picture:cold_pic},
    {id: 16, english: "Dry", vietnamese: "Khô hanh", example:"Phơi khô quần áo", audio:dry, picture:dry_pic},
    {id: 17, english: "Wet", vietnamese: "Ẩm ướt", example:"Quần áo ướt", audio:wet, picture:wet_pic},
    {id: 19, english: "Changeable", vietnamese: "Hay thay đổi", example:"Thay vải lanh", audio:changeable, picture:changeable_pic},
    {id: 20, english: "Fall/dry season", vietnamese: "Mùa mưa /khô", example:"Khô", audio:fall, picture:fall_pic},
    {id: 21, english: "Interesting", vietnamese: "Thú vị", example:"Nó là thú vị", audio:interesting, picture:interesting_pic},
    {id: 22, english: "Cool", vietnamese: "Mát mẻ", example:"Mát mẻ", audio:cool, picture:cool_pic},
    {id: 23, english: "Summer", vietnamese: "Mùa hè/hạ", example:"Mùa hè nóng", audio:summer, picture:summer_pic},
    {id: 24, english: "Spring", vietnamese: "Mùa xuân", example:"Mùa xuân mát mẻ", audio:spring, picture:spring_pic},
    {id: 25, english: "Fall/Autumn", vietnamese: "Mùa thu", example:"Mùa thu mưa", audio:autumn, picture:autumn_pic},
    {id: 26, english: "Winter", vietnamese: "Mùa đông", example:"Mùa đông lạnh giá", audio:winter, picture:winter_pic},
    {id: 27, english: "Season", vietnamese: "Mùa", example:"4 mùa", audio:season, picture:season_pic},
    {id: 28, english: "Special", vietnamese: "Đặc biệt", example:"Vượt qua đặc biệt", audio:special, picture:special_pic},
    {id: 29, english: "Different", vietnamese: "Khác biệt", example:"âm thanh khác nhau", audio:different, picture:different_pic},
    {id: 30, english: "Plan", vietnamese: "Kế hoạch", example:"kế hoạch tốt", audio:plan, picture:plan_pic},
    {id: 31, english: "End of", vietnamese: "Cuối", example:"Cuối", audio:end_of, picture:end_of_pic},
    {id: 32, english: "Place", vietnamese: "Nơi/ địa điểm", example:"Nơi thú vị", audio:place, picture:place_pic},
    {id: 33, english: "Temperature", vietnamese: "Nhiệt độ", example:"nhiệt độ trên 0", audio:temperature, picture:temperature_pic},
    {id: 34, english: "Differences", vietnamese: "Sự khác nhau", example:"Sự khác nhau", audio:differences, picture:differences_pic},
    {id: 35, english: "Between", vietnamese: "Giữa", example:"Giữa bạn và tôi", audio:between, picture:between_pic},
    {id: 36, english: "From - to", vietnamese: "Từ - đến", example:"Từ nhà ga đến nhà", audio:from_to, picture:from_to_pic},
    {id: 37, english: "Rainy/dry season", vietnamese: "Mùa mưa /và mùa khô", example:"Mùa mưa", audio:rainy, picture:rainy_pic},
    {id: 38, english: "Come", vietnamese: "Đến", example:"Đến", audio:come, picture:come_pic},
    {id: 39, english: "This occasion", vietnamese: "Dịp này", example:"Dịp này", audio:this_occasion, picture:this_occasion_pic},

]